import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { useToast } from '../../hooks/use-toast';
import { Card, CardContent } from '../ui/card';
import { receptionApiErrorMessage } from './receptionConstants';
import {
  GraduationCap, Calendar, Users, Phone, AlertTriangle, CheckCircle, Clock, Mail,
} from 'lucide-react';

function StatCard({ title, value, icon: Icon, color, to }) {
  const inner = (
    <Card className="border-border hover:shadow-md transition-shadow">
      <CardContent className="p-5 flex items-center gap-4">
        <div className={`p-3 rounded-xl ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className="text-2xl font-bold text-foreground">{value ?? 0}</p>
        </div>
      </CardContent>
    </Card>
  );
  return to ? <Link to={to}>{inner}</Link> : inner;
}

export default function ReceptionDashboard() {
  const { toast } = useToast();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/reception/dashboard')
      .then((res) => setStats(res.data?.data || null))
      .catch((e) => {
        setStats(null);
        toast({ title: 'Error', description: receptionApiErrorMessage(e), variant: 'destructive' });
      })
      .finally(() => setLoading(false));
  }, [toast]);

  if (loading) {
    return <div className="p-8 text-center text-muted-foreground">Loading dashboard…</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Reception Dashboard</h1>
        <p className="text-muted-foreground">Admission inquiries, visitors, and front desk overview</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Total Admission Inquiries" value={stats?.total_inquiries} icon={Mail} color="bg-violet-600" to="/reception/inquiries" />
        <StatCard title="Today's Inquiries" value={stats?.today_inquiries} icon={Calendar} color="bg-purple-600" />
        <StatCard title="Today's Follow-ups" value={stats?.today_followups} icon={Clock} color="bg-amber-600" to="/reception/followups" />
        <StatCard title="Visitors Today" value={stats?.visitors_today} icon={Users} color="bg-blue-600" to="/reception/visitors" />
        <StatCard title="Phone Calls Today" value={stats?.phone_calls_today} icon={Phone} color="bg-cyan-600" to="/reception/phone-calls" />
        <StatCard title="Open Complaints" value={stats?.complaints_open} icon={AlertTriangle} color="bg-red-600" to="/reception/complaints" />
        <StatCard title="Admissions Converted" value={stats?.admissions_converted} icon={CheckCircle} color="bg-green-600" />
        <StatCard title="Pending Follow-ups" value={stats?.pending_followups} icon={Clock} color="bg-orange-600" to="/reception/followups" />
      </div>
    </div>
  );
}
